import { useEffect, useState } from 'react';

/** §7.8 breakpoints. Named here so layout code reads as intent, not as numbers. */
export const BREAKPOINT = {
  wide: '(min-width: 1280px)',
  medium: '(min-width: 768px)',
} as const;

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

export type Layout = 'wide' | 'medium' | 'compact';

/**
 * >=1280 wide: Compose | Queue side by side, full nav.
 * 768-1279 medium: Compose over Queue, nav is a rail.
 * <768 compact: Console is tabbed, nav is a drawer.
 */
export function useLayout(): Layout {
  const wide = useMediaQuery(BREAKPOINT.wide);
  const medium = useMediaQuery(BREAKPOINT.medium);
  return wide ? 'wide' : medium ? 'medium' : 'compact';
}
